import { ProfileData } from "./Profile.types";

export const ProfilesList: ProfileData[] = [
  {
    id: "nagapriya",
    name: "Nagapriya",
    picture: "jpg",
    role: "Backend Dev Engineer",
    email: "nagapriya.sivabalan@gmail.com",
    summary:
      "<ul><li>I am an enthusiastic learner with a strong drive to explore and adapt to new technologies.</li><li>I believe in learning by doing and have consistently taken up tasks with dedication.</li><li>I’ve been actively working with backend technologies like Java and Spring Boot, and I’m eager to expand my knowledge even further.</li><li>I am passionate about contributing to meaningful work, constantly upgrading my skills, and giving my best in every opportunity I get.</li></ul>",
    experience: [
      {
        company: "CodeTech IT Solutions",
        role: "UI UX Designer",
        summary:
          "<ul><li>Created user-friendly wireframes and mobile app prototypes using Figma to enhance user experience.</li><li>Designed portfolio website layout with a focus on clean interface and intuitive navigation.</li><li>Collaborated with developers to ensure accurate implementation of UI/UX designs.</li></ul>",
      },
    ],

    mentorBridgeExp: {
      company: "Securosphere",
      role: "Co-Founder | Backend Dev Engineer",
      summary:
        "<ul><li>Worked as a Backend Developer, building scalable and secure applications using Spring Boot and Java.</li><li>Developed and integrated RESTful APIs to support frontend functionality and third-party services.</li><li>Implemented JWT-based authentication and authorization for secure user access.</li><li>Managed and optimized databases like  MongoDB for efficient data storage and retrieval.</li><li>Handled QA deployment and testing processes, ensuring product reliability and performance.</li><li>Used tools like Docker for containerization and smooth deployment across environments.</li></ul>",
      website: "https://www.securosphere.in/",
    },
    skillSets: [
      "Java Springboot",
      "Node.js",
      "Python",
      "AWS",
      "Docker",
      "CI/CD",
    ],
    inspirations: ["APJ Abdul Kalam"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/nagapriya-sivablan/",
      gitHub: "https://github.com/Nagapriya10",
    },
  },
  {
    id: "pavithraharini",
    name: "Pavithraharini S",
    picture: "jpeg",
    role: "Backend Dev engineer",
    email: "pavithraharini123@gmail.com",
    summary:
      "<ul><li>Developed the product with the Easy user interfaces </li><li>Analysed and developed the easy managing facility </li></ul>",
    experience: [
      {
        company: "Accent techno soft",
        role: "Frontend developer",
        summary:
          "<ul><li>Designed product interfaces and user flows for the vehicle management with the booking facilities , contributing to the overall user experience of the platform.</li><li>Created API documentation to facilitate easy understanding and implementation.</li></ul>",
        website: "",
      },
    ],
    mentorBridgeExp: {
      company: "Stublab",
      role: "Co-Founder | Technical Analyst",
      summary:
        "<ul><li>Developed a service to render and send email templates </li><li>Created API documentation to facilitate easy understanding and implementation.</li><li>Enabled modular email customization for various use cases.</li></ul>",
      website: "https://www.stublab.in/",
    },
    skillSets: ["React", "TypeScript", "Node.js", "AWS"],
    inspirations: ["APJ Abdul Kalam", "Ratan Tata"],
    socialLinks: {
      linkedIn: "www.linkedin.com/in/pavithraharini-s-267506266",
      gitHub: "https://github.com/Pavithrahar",
      website: "",
    },
  },
  {
    id: "Jeyashree",
    name: "Jeyashree S",
    picture: "jpg",
    role: "Frontend Dev Engineer",
    email: "jeyashreeselvan9@gmail.com",
    summary:
      "<ul><li>I am currently pursuing final year of B.E. in Computer Science and Engineering at SSMIET. I am a passionate front-end developer with experience in building responsive and user-friendly web applications.</li><li>I am the Co-founder and Front-End Developer of Securosphere. My core areas of interest lie in Front-End Development and UI/UX Design. I am proficient in technologies such as HTML, CSS, JavaScript, React.js, Bootstrap, and TypeScript. Additionally, I have strong skills in UI design, with hands-on experience using design tools like Figma and Canva.</li></ul>",
    experience: [
      {
        company: "Virtualtechnology",
        role: "Frontend Developer",
        summary:
          "<ul><li>Using front-end development, I completed a Pet shop website and built a responsive web design.</li><li>Only using HTML, CSS, Bootstrap, and media queries to make responsive pages.</li></ul>",
      },
      {
        company: "Seval Software Solution",
        role: "Front-end Engineer",
        summary:
          "<ul><li>I have completed a web development internship during which I worked on a banking system project using HTML, CSS, and JavaScript.</li><li>Created interactive and visually appealing interfaces.</li></ul>",
      },
    ],
    mentorBridgeExp: {
      company: "Securosphere",
      role: "Co-Founder | Front-End Engineer",
      summary:
        "<ul><li>I have contributed to key modules such as the Registration Page, Multi-Factor Authentication (MFA), reCAPTCHA, GitHub integration, cookie management, and RESTful API integration.</li><li>I have actively participated in pitching and promoting our product at various platforms and events.</li></ul>",
      website: "http://securosphere.in",
    },
    skillSets: ["HTML", "CSS", "Bootstrap", "React.js", "TypeScript", "UI/UX"],
    inspirations: ["Ratan Tata", "Dr. A.P.J. Abdul Kalam"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/jeya-shree-s/",
      gitHub: "https://github.com/JEYASHREESELVAN",
    },
  },
  {
    id: "karpagam",
    name: "Karpagam",
    picture: "jpg",
    role: " UI/UX DESIGNER",
    email: " mkarpagam025@gmail.com ",
    summary:
      "<ul><li>A passionate UI/UX Designer and Web Developer with hands-on experience in designing and developing engaging digital experiences.</li><li>Adept at using design tools like Figma, Adobe XD, and  alongside web technologies like HTML, CSS, and JavaScript. Strong problem-solving skills with a keen eye for detail and user-centered design..</li></ul>",
    experience: [
      {
        company: " Accent Techno Soft",
        role: " UI&UX DESIGNER",
        summary:
          "<ul><li>•	Designed wireframes and interactive prototypes for an Event Management System..</li><li> Created engaging wireframes and interactive prototypes.</li></ul>",
        website:
          "https://www.figma.com/design/HyBQVgsHGb67TTs6Y96nFy/Untitled?node-id=0-1&p=f&t=raFi1lRsHz7cw53B-0",
      },
      {
        company: "Sarva vidya solutions ",
        role: "UI&UX DESIGNER",
        summary:
          "<ul><li>•	Created a detailed travel website using Figma.</li><li>Included insights on travel packages, itineraries, meal plans, and pricing variations..</li></ul>",
        website:
          "https://www.figma.com/proto/PQMxJnCESu94zEQDnoXw0F/Untitled?node-id=53-2&starting-point-node-id=53%3A2",
      },
      {
        company: "work zone  ",
        role: "UI&UX DESIGNER",
        summary:
          "<ul><li>.</li><li>Created API documentation to facilitate easy understanding and implementation.</li></ul>",
        website:
          " https://www.figma.com/design/hnvpeugDy65g9SgWJd1ctR/Untitled?node-id=0-1&p=f&t=aIeG0aXh7U4fZjIj-0",
      },
      {
        company: "Congono Rise Info Tech ",
        role: "UI&UX DESIGNER",
        summary:
          "<ul><li>•	Designed a gaming product launch website using Figma..</li><li> Created engaging wireframes and interactive prototypes.</li></ul>",
        website:
          "https://www.figma.com/design/z9E3WaDGUwBIwpP4NWEtKj/Untitled?node-id=0-1&p=f&t=QaeFA7vRIgw6liS5-0",
      },
    ],
    mentorBridgeExp: {
      company: "SecuroSphere ",
      role: "Co-Founder | Frontend Developer",
      summary:
        "<ul><li>Built secure LinkedIn & Microsoft OAuth login flows, integrated MFA and JWT-based authentication for seamless access control..</li><li>Developed custom user/team management modules, enhancing scalability, security, and user experience on SecuroSphere..</li></ul>",
      website: "http://SecuroSphere.in",
    },

    skillSets: [
      "figma",
      " Balsamiq",
      " Adobe XD",
      "Canva",
      " Adobe Illustrator",
      " Framer",
      "InVision",
    ],
    inspirations: [" Mary curry"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/karpagam-ms ",
      gitHub: " https://github.com/karpagamm  ",
    },
  },
  {
    id: "kajalakshmi",
    name: "Kajalakshmi M",
    picture: "jpeg",
    role: "Frontend Dev Engineer",
    email: "mkajalakshmi@gmail.com",
    summary:
      "<ul><li>I'm a passionate Frontend Developer and Co-founder of SecuroSphere, currently pursuing my Bachelor's degree in Computer Science Engineering at SSMIET.</li><li>Specialized in building scalable, responsive user interfaces using React.js and Bootstrap, focusing on performance and accessibility.</li><li>Beyond development and design, I also created and presented the pitch deck for SecuroSphere, helping effectively communicate our product vision to internal teams, college management, and potential collaborators.</li></ul>",
    experience: [
      {
        company: "Seval Software Solutions",
        role: "Frontend Developer",
        summary:
          "<ul><li>TastyTrails website frontend was built with a focus on clean design, responsiveness, and intuitive user experience using React.js and Bootstrap.</li><li>Developed interactive UI components and implemented smooth navigation flows to enhance user engagement across the platform.</li></ul>",
      },
    ],
    mentorBridgeExp: {
      company: "SecuroSphere",
      role: "Co-founder | Frontend Developer",
      summary:
        "<p>Contributed to the complete UI development using React.js, TypeScript, and Bootstrap. Designed UI/UX layouts and branding assets using Figma and Canva. Worked on core product pages including login, email verification, OTP entry, and email template setup. Collaborated with the team through GitHub, Jira, Teams, and Confluence. Helped design and present the pitch deck to effectively communicate the product vision to stakeholders.</p>",
      website: "https://securosphere.in",
    },
    skillSets: [
      "HTML",
      "CSS",
      "Bootstrap",
      "React",
      "JavaScript",
      "Figma",
      "Python",
      "Java",
    ],
    inspirations: ["Mahakavi Bharathi", "APJ Abdul Kalam"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/kajalakshmi-m",
      gitHub: "https://github.com/Kajalakshmi11",
    },
  },
  {
    id: "viji",
    name: "Vijayalakshmi T",
    picture: "jpg",
    role: "Frontend Dev Engineer",
    email: "vijayalakshmifsd@gmail.com",
    summary:
      "<ul><li>Designed product interfaces and user flows, contributing to the overall user experience of the platform.</li><li>Created API documentation to facilitate easy understanding and implementation.</li></ul>",
    experience: [
      {
        company: "Accent Techno Software ",
        role: "Webdeveloper",
        summary:
          "<ul><li>Developed and maintained the user interface of a web-based Rail Pass Management System using HTML5, CSS3, and JavaScript. Ensured a clean, intuitive, and functional design that improved user interaction and engagement.</li></ul>",
      },
      {
        company: "Virtuospark",
        role: "Digital Marketing",
        summary:
          "<ul><li>Designed a poster based on Webdevelopment, contributing to the overall user experience of the platform.</li><li>Created API documentation to facilitate easy understanding and implementation.</li></ul>",
      },
    ],
    mentorBridgeExp: {
      company: "Stublab",
      role: "Co-Founder | Front End Engineer",
      summary:
        "<ul><li>Designed product interfaces and user flows, contributing to the overall user experience of the platform.</li></ul>",
      website: "http://stublab.info",
    },
    skillSets: [
      "HTML",
      "CSS",
      "JavaScript",
      "React.js",
      "Bootstrap",
      "Digital Marketing",
      "UI&UX Designer",
    ],
    inspirations: ["APJ Abdul Kalam"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/public-profile/settings ",
      gitHub: " https://github.com/vijayalakshmiTHIRUMOORTHY  ",
    },
  },
  {
    id: "Kiruthika_G",
    name: "Kiruthika G",
    picture: "jpeg",
    role: "Frontend Dev Engineer",
    email: "kiruthikaganesan757@gmail.com",
    summary:
      "<ul><li>Creative and focused Frontend Developer with hands-on experience in building mobile applications using React Native. </li><li> As the co-founder of StuPro, I’ve designed smooth, user-friendly interfaces and implemented key features like push notifications and loading indicators with Context API.</li><li>Proficient in Java and modern frontend practices, with a good understanding of Agile development and tools like Jira. Dedicated to crafting clean, responsive designs that enhance user engagement and functionality.</li></ul>",
    experience: [
      {
        company: "System Tron",
        role: "Web developer",
        summary:
          "<ul><li>Developed Netflix Clone which enhanced my knowledge in HTML,CSS,Javascript.</li></ul>",
      },
    ],
    mentorBridgeExp: {
      company: "StuPro",
      role: "Co-Founder | Frontend Dev Engineer",
      summary:
        "<ul><li>Developed user-friendly mobile app screens using React Native.</li><li>Push Notification System – Worked on FCM to send Sentence of the Day updates.</li><li>Activity Indicator Component – Designed a loading spinner and GIF-based loaders for better UI responsiveness.</li><li>Dynamic & Interactive User Interfaces – Developed smooth and engaging UI components in React Native.</li></ul>",
      website: "http://stupro.info",
    },
    skillSets: [
      "React",
      "TypeScript",
      "Java",
      "React Native",
      "HTML",
      "CSS",
      "JavaScript",
      "UI/UX",
    ],
    inspirations: ["APJ Abdul Kalam"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/kiruthii/",
      gitHub: "https://github.com/kiruthii",
      website: "",
    },
  },
  {
    id: "Nithya_Bala_M",
    name: "Nithya Bala M",
    picture: "jpg",
    role: "Frontend Dev Engineer",
    email: "nithyabala02062004@gmail.com",
    summary:
      "<ul><li>Frontend Developer with a good understanding of HTML, CSS, and React.js. Skilled in building responsive web designs and creating clean, user-friendly interfaces.</li><li>Experienced in using Figma for wireframing and prototyping. Interested in web development and working in a team environment. Also familiar with Excel and SQL, helpful for basic data handling and integration. </li></ul>",
    experience: [
      {
        company: "Seval software solutions.",
        role: "Frontend dev engineer",
        summary:
          "<ul><li> Acquired practical knowledge in designing and developing web pages using HTML and CSS, focusing on user-friendly layouts. Built foundational skills in JavaScript to introduce dynamic content and improve user interaction across various web projects.</li><li> Gained a deeper understanding of Web development tools like HTML, CSS and Javascript, improving my ability to build websites.</li></ul>",
        website: "",
      },
    ],
    mentorBridgeExp: {
      company: "StuPro",
      role: "Co-Founder | Front end Dev Engineer",
      summary:
        "<ul><li>  Built responsive and user-friendly mobile app screens using React Native Worked on navigation and implemented UI animations across the entire app to enhance user interactions. Developed the Forgot Password page with a seamless navigation flow.</li><li> Managed state handling to optimize component behavior and improve app performance. Contributed to UI/UX design and collaborated with the team to create a clean and intuitive user experience. Followed the Agile methodology, ensuring continuous improvements through iterative feedback..</li></ul>",
      website: "http://stupro.info",
    },
    skillSets: [
      "HTML",
      "CSS",
      "React js",
      "Javascript",
      "Figma (Wireframing & Prototyping)",
      "SQL ",
      "Excel ",
    ],
    inspirations: ["APJ Abdul Kalam"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/nithyabala02/",
      gitHub: "https://github.com/Nithyabala2004",
      website: "",
    },
  },
  {
    id: "Sakthi_Priya_S",
    name: "Sakthi Priya S",
    picture: "jpg",
    role: "Frontend Dev Engineer",
    email: "sakthikannan823@gmail.com",
    summary:
      "<ul><li> A frontend developer passionate about creating user-friendly interfaces. I specialize in  React Native and UI/UX design, focusing on building smooth and engaging digital experiences..</li><li> Currently, I contribute to StuPro, a platform that helps students transition into professionals. My role involves frontend development, UI enhancements, and product marketing to make the platform more intuitive and effective.</li></ul>",
    experience: [],
    mentorBridgeExp: {
      company: "StuPro",
      role: "Co-Founder | Frontend Dev Engineer | UX designer",
      summary:
        "<ul><li> Authentication UI Design – Designed an intuitive login/signup experience to enhance user onboarding.</li><li> Interactive Puzzle Card Component – Developed an engaging puzzle feature to boost user interaction.</li><li> API Integration – Connected the frontend with the backend for seamless data flow.</li><li> Product Analytics Integration – Implemented PostHog to track user behavior , improve platform insights and plays a  vital role in marketing.</li>  </ul>",
      website: "http://stupro.info",
    },
    skillSets: [
      "UI/UX",
      "JavaScript",
      "React Native",
      "TypeScript",
      "Html",
      "css",
    ],
    inspirations: ["William Hanna", "Virat Kohli", "Senthil Kumar T"],
    socialLinks: {
      linkedIn: " https://www.linkedin.com/in/sakthi-priya-729156287/",
      gitHub: " https://github.com/sakthipriya2326/sakthi",
      website: "",
    },
  },
  {
    id: "Karthekeyan_M",
    name: "Karthekeyan M",
    picture: "jpg",
    role: "Frontend Dev Engineer",
    email: "karthekeyan.muruganantham@gmail.com",
    summary:
      "<ul><li>I am a passionate Full Stack Developer with experience in building web applications using MERN stack.</li><li>I have worked on different projects like e-commerce websites and API tools, and I enjoy creating user-friendly and responsive web apps.</li></ul>",
    experience: [
      {
        company: "Vinculo",
        role: "Full Stack Developer",
        summary:
          "<ul><li>Developed responsive and user-friendly UI using React js.Integrated Razorpay payment gateway to enable secure and seamless transactions.</li><li>Built APIs with Node.js and Express.js for fetching product and user data from MongoDB.<li></ul>",
        website: "https://www.vinculoshop.com",
      },
    ],
    mentorBridgeExp: {
      company: "Stublab",
      role: "Co-Founder | Frontend Dev Engineer",
      summary:
        "<ul><li>Enhanced the landing page to improve user experience and visual appeal.Developed the frontend using React.js with a focus on responsiveness and usability.</li><li>Integrated APIs to enable dynamic data interaction between the frontend and backend.</li><li>Designed the project logo to align with the application's theme and branding.</li></ul>",
      website: "http://www.stublab.in",
    },
    skillSets: [
      "Java",
      "HTML",
      "CSS",
      "Javascript",
      "React JS",
      "node JS",
      "MongoDB",
      "Figma",
      "Git",
      "GitHub",
      "Canva",
    ],
    inspirations: ["MS Dhoni", "Nicholas Pooran"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/karthekeyan-m/",
      gitHub: "https://github.com/karthi049",
      website: "",
    },
  },
  {
    id: "harini",
    name: "HARINI S",
    picture: "jpg",
    role: "Backend Dev Engineer",
    email: "harinisundar81002@gmail.com",
    summary:
      "<ul><li>Innovative UI/UX Designer, Graphic Designer, and Backend Developer with a strong foundation in crafting intuitive digital experiences and scalable backend solutions.</li><li>Proficient in Figma, Adobe Creative Suite (Photoshop, Illustrator, Jitter), Elementor, HTML, CSS, JavaScript, React.js, Spring Boot, and MySQL, I specialize in designing user-centric interfaces, developing robust APIs, and creating visually compelling graphics.</li><li>With hands-on experience in a UI/UX internship at Sarva Vidhya, I have designed engaging websites, mobile apps, wireframes, and brand identities.</li><li>My graphic design expertise includes logos, posters, product labels, and marketing materials, with notable work such as the Zuha Perfumes logo and label, product design for Nigal Mazhil, and product design for Mentor Bridge.</li><li>As a Backend Developer, I focus on building efficient APIs with Spring Boot, contributing to projects like StubLab, an AI-integrated stub server streamlining API development and testing.</li><li>Additionally, my experience working at Mentor Bridge, a startup, has enhanced my backend development skills, allowing me to gain deeper insights into API architecture and system scalability while also contributing to product design.</li><li>Passionate about design, technology, and innovation, I thrive in dynamic environments, leveraging my cross-disciplinary expertise to deliver impactful digital solutions that balance functionality, aesthetics, and performance.</li></ul>",

    experience: [
      {
        company: "Sarva Vidhya Solutions",
        role: "UI/UX and Graphic Designer",
        summary:
          "<ul><li>Gained hands-on experience in UI/UX design, focusing on user-centered design principles.</li><li>Created mockups, wireframes, and prototypes to enhance user experience and interface design.</li><li>Designed logos, product designs, and labels for various projects, ensuring brand consistency.</li><li>Worked with Adobe Creative Suite (Photoshop, Illustrator), Elementor, Jitter, Figma, and Canva to develop high-quality visual assets.</li><li>Designed engaging marketing materials, posters, and branding elements for digital and print media.</li><li>Contributed to the development of interactive and responsive UI components for web platforms.</li></ul>",
        website: "",
      },
    ],

    mentorBridgeExp: {
      company: "StubLab",

      role: "Co-Founder | Backend Dev Engineer",

      summary:
        "<ul><li>Developed and documented REST APIs using Spring Boot to ensure seamless integration and functionality.</li><li>Created API documentation to facilitate easy understanding and implementation.</li><li>Conducted API testing using Postman to validate endpoints, responses, and performance.</li><li>Collaborated with the team to improve design consistency and enhance the platform’s usability.</li></ul>",

      website: "http://stublab.in",
    },

    skillSets: [
      "React",

      "Spring Boot",

      "UI/UX",

      "AWS",

      "Docker",

      "CI/CD",

      "GitHub",

      "MongoDB",
    ],

    inspirations: ["Sunitha Williams"],

    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/harini-sundaralingam-13348835a",

      gitHub: "https://github.com/Harinisundar08",
      website: "",
    },
  },
  {
    id: "devaki_ravi",
    name: "Devaki Ravi",
    picture: "jpeg",
    role: "Backend Dev Engineer",
    email: "devakiravi226@gmail.com",
    summary:
      "<ul><li>Driven and detail-oriented Backend Developer with hands-on experience in designing and developing robust, scalable APIs using Java and the Spring Boot framework.</li><li> My expertise lies in creating efficient backend systems that ensure performance, maintainability, and seamless integration with frontend services.</li></ul>",
    experience: [
      {
        company: "Seval Software Solutions",
        role: "intern",
        summary:
          "<ul><li>I gained practical experience in full-stack development.</li><li> I worked on building responsive web pages using HTML, CSS, and JavaScript, with an emphasis on usability, structure, and performance—giving me a solid foundation in how backend services connect with frontend interfaces.</li></ul>",
        website: "",
      },
    ],
    mentorBridgeExp: {
      company: "Stublab",
      role: "Co-Founder | Backend Dev Engineer",
      summary:
        "<ul><li>I worked as a backend lead, where I was responsible for developing RESTful APIs following best coding practices.</li><li>My role focused on building scalable and maintainable backend architectures, improving system performance, and contributing to real-world product development in a startup environment.</li></ul>",
      website: "https://www.stublab.in/",
    },
    skillSets: [
      "Java",
      "Springboot",
      "Python",
      "Html",
      "css",
      "MongoDB",
      "Git",
      "Github",
      "Figma",
    ],
    inspirations: ["APJ Abdul Kalam", "Srinivasa Ramanujan"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/devaki-r-701b882b4/",
      gitHub: "https://github.com/devakiravi",
      website: "",
    },
  },
  {
    id: "sherin-sithara",
    name: "Sherin Sithara M",
    picture: "jpeg",
    role: "Backend Dev Engineer",
    email: "sherinsithara0008@gmail.com",
    summary:
      "<ul><li>A passionate and detail-oriented developer with experience in UI/UX design, front-end, and back-end development.</li><li>Skilled in designing clean, user-friendly interfaces through wireframes and prototypes.</li><li>Experienced in building responsive front-end layouts based on project needs.</li><li>Developed back-end features to ensure efficient data handling and reliable application performance.</li><li>As a Co-founder, contributed to product planning, design, and development with a focus on user-centered digital solutions.</li><li>Values intuitive design, clear documentation, and continuous learning to create impactful and functional products.</li></ul>",
    experience: [
      {
        company: "Seval Software Solutions",
        role: "Frontend Dev Engineer | UI/UX Desiger",
        summary:
          "<ul><li>Designed clean and user-friendly interfaces using wireframes and prototypes.</li><li>Improved user flows for better navigation and overall experience.</li><li>Documented designs and front-end features for easy updates and collaboration.</li></ul>",
        website: "",
      },
    ],
    mentorBridgeExp: {
      company: "StubLab",
      role: "Co-Founder | Backend Dev Engineer | UI/UX Desiger",
      summary:
        "<ul><li>Designed product interfaces and user flows, contributing to the overall user experience of the platform.</li><li>Created API documentation to facilitate easy understanding and implementation.</li></ul>",
      website: "https://stublab.in/",
    },
    skillSets: [
      "C/C++",
      "Java",
      "Python",
      "HTML",
      "CSS",
      "JavaScript",
      "Node.js",
      "MongoDB",
      "CI/CD",
      "Git/GitHub",
      "Figma",
      "Canva",
    ],
    inspirations: ["Elon Musk", "MS Dhoni"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/sherin-sithara-1a6244263/",
      gitHub: "https://github.com/sherinsithara",
      website: "",
    },
  },
  {
    id: "umar_farook",
    name: "Umar Farook J",
    picture: "png",
    role: "Frontend Dev Engineer | Technical Analyst",
    email: "umarfarookj06@gmail.com",
    summary:
      "<ul><li>A motivated and enthusiastic web development fresher with a strong foundation in HTML, CSS, JavaScript, and modern frameworks like React.js.</li><li>Passionate about building responsive, user-friendly web applications and eager to learn new technologies.</li><li>Seeking an entry-level position to leverage my skills in front-end development and contribute to innovative projects while growing professionally in a dynamic environment.</li></ul>",
    experience: [
      {
        company: "Vinculo",
        role: "Full Stack Developer",
        summary:
          "<ul><p>As a key developer for Vinculo, an e-commerce platform for SSM Garments, I contributed to building a seamless and engaging shopping experience using MERN technology. My role focused on developing essential user-facing features and ensuring a responsive, intuitive, and secure platform across devices.</p><li>Authentication System – Designed and implemented a secure Login & Register page, integrating authentication mechanisms for seamless user access.</li><li>Product Display & View – Developed an interactive product listing and detail page, optimizing UI/UX for effortless browsing.</li><li>Order & Checkout Flow – Created a smooth order processing system, including an Order Page and Order Confirmation Page to enhance the purchasing experience.</li><li>User Profile Management – Designed a dynamic Profile Page where users can manage their details, track orders, and update preferences.</li><li>Responsive Footer Design – Built a fully responsive footer for both desktop and mobile views, ensuring a clean and organized layout.</li></ul>",
        website: "https://vinculoshop.com/",
      },
    ],
    mentorBridgeExp: {
      company: "Stublab",
      role: "Co-Founder | Analyst",
      summary:
        "<ul><p>As a Co-Founder and Analyst at StubLab, I have played a crucial role in developing a seamless API mocking platform that empowers developers to create, test, and iterate APIs efficiently. My contributions span both frontend and backend development, focusing on user experience, API management, and automation.</p><li>Landing Page Development – Designed and built a visually engaging, responsive landing page to introduce users to the platform.</li><li>Model Page Implementation – Developed an interactive model page for structuring and managing mock API responses.</li><li>API Configuration Card – Created a dynamic API configuration card, allowing users to define endpoints, request types, and response behaviors easily.</li><li>Swagger Integration – Implemented Swagger UI for API documentation, enabling developers to explore and test API functionalities within the platform.</li><li>Status Code Management – Developed API endpoints to update and manage HTTP status codes for mock responses.</li><li>Application Management – Implemented functionalities to delete applications from the system.</li><li>Model & Form Updates – Created APIs to update models and form structures, allowing for flexible API testing configurations.</li></ul>",
      website: "https://stublab.in",
    },
    skillSets: [
      "React",
      "TypeScript",
      "Node.js",
      "Java",
      "HTML",
      "CSS",
      "JavaScript",
      "Bootstrap",
      "Express.js",
      "MongoDB",
      "Git",
      "Github",
    ],
    inspirations: ["M S Dhoni"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/umar-farook-j-56b371280",
      gitHub: "https://github.com/Umarfarook1912",
      website: "https://umarfarookj.vercel.app/",
    },
  },
  {
    id: "jeyaraman",
    name: "Jeyaraman S",
    picture: "jpg",
    role: "Frontend Dev Engineer | UI/UX Designer",
    email: "jeyaraman.saravanan23@gmail.com",
    summary:
      "<ul><li>Web developer with strong skills in JavaScript, TypeScript, and React.js.</li><li>Proficient in building responsive web applications and integrating APIs efficiently.</li><li>Passionate about creating seamless user experiences and optimizing frontend performance.</li></ul>",
    experience: [
      {
        company: "Vinculo | e-Commerce Platform",
        role: "Full-Stack Developer Intern",
        summary:
          "<ul><li>Developed a complete e-commerce platform using React, Node.js, Express.js, and MongoDB.</li><li>Designed and implemented key features such as user authentication, product search and browsing, shopping cart, checkout, and payment system integration.</li><li>Focused on enhancing UI/UX by creating a responsive and user-friendly interface.</li><li>Specifically contributed to UI design, search functionality, and payment system integration.</li></ul>",
        website: "https://vinculoshop.com",
      },
      {
        company: "Tech Vaseegrah - Billzzy Landing Page",
        role: "Frontend Developer Intern",
        summary:
          "<ul><li>Designed and developed a modern, responsive landing page using React, TypeScript, and Tailwind CSS.</li><li>Implemented lazy loading, animations using Framer Motion, and reusable components for scalability.</li><li>Focused on performance optimization to enhance user experience.</li></ul>",
        website: "https://tech-vaseegrah.vercel.app/",
      },
    ],
    mentorBridgeExp: {
      company: "SecuroSphere",
      role: "Frontend Dev Engineer",
      summary:
        "<ul><li>Led frontend development and UI/UX design for SecuroSphere.</li><li>Developed interfaces in Figma and implemented them using React.js and TypeScript.</li><li>Integrated APIs with TanStack Query and managed deployments on Vercel.</li><li>Used Hotjar, PostHog, Google Analytics, and Sentry for tracking user behavior and performance.</li><li>Handled product pitching and social media promotion.</li></ul>",
      website: "https://www.securosphere.in/",
    },
    skillSets: [
      "Java",
      "JavaScript",
      "TypeScript",
      "React.js",
      "Tailwind CSS",
      "Figma",
      "GitHub",
    ],
    inspirations: ["Mark Zuckerberg", "Vetrimaaran"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/jeyaraman23/",
      gitHub: "https://github.com/Jagan6923",
      website: "https://jeyaraman.me/",
    },
  },
  {
    id: "balakrishnan",
    name: "Bala Krishnan",
    picture: "jpg",
    role: "Mobile App Developer",
    email: "sbkrish2506@gmail.com",
    summary:
      "<ul><li>I am a passionate and results-driven React Native Developer with a strong foundation in JavaScript, React.js, and TypeScript. As the co-founder of StuPro, I specialize in designing and developing high-performing, user-friendly mobile applications.</li><li> With a keen interest in Data Science and AI, I constantly explore ways to integrate analytics into app development to enhance user experiences.</li><li> My UI/UX expertise in Figma allows me to create intuitive, visually appealing applications that prioritize user engagement.</li><li> Beyond development, I excel in problem-solving, critical thinking, and collaboration, ensuring efficient teamwork in agile environments.</li></ul>",
    mentorBridgeExp: {
      company: "StuPro",
      role: "Co-Founder | Mobile App Developer",
      summary:
        "<ul><li>I gained extensive hands-on experience in JavaScript, React.js, and React Native, contributing significantly to the development of a TypeScript-based React Native application named Stupro.</li><li>I was responsible for creating multiple pages and modules, including onboarding, Daily Challenges, Profile, and Leaderboard pages, while implementing key features such as carousels, async storage, animations, and navigation.</li><li> For the onboarding page, I utilized FlatList with default animations and pagination to enhance user experience.</li><li> On the Daily Challenges page, I mapped tasks dynamically to create an engaging interface.</li><li> The Profile page was designed with a card-style layout to display user information, streak details, and access to change password and preferences pages.</li><li> The Leaderboard page showcased a list of top performers based on points earned through daily challenges.</li><li> I leveraged the react-native-reanimated-carousel package to implement a carousel on the home page and used Async Storage for offline storage of profile details and user credentials.</li><li> Navigation across the application was seamlessly handled using React Native Navigation, while animations were enhanced with the React Native Reanimated package to improve user experience.</li><li> Additionally, I collaborated closely with the team to develop and refine application features, actively participating in team discussions, problem-solving sessions, and code reviews in an agile environment.</li><li> My role also involved using Figma to design sitemaps and structure multiple pages, ensuring a seamless and intuitive user experience.</li><li> This experience allowed me to grow as a developer, fostering collaboration, continuous learning, and a strong focus on delivering high-quality solutions.</li></ul>",
      website: "http://stupro.info",
    },
    experience: [
      {
        company: "Break Time Tv",
        role: "Mobile App Developer",
        summary:
          "<ul><li>Break Time Tv - Live TV Streaming App is a feature-rich React Native application designed to provide a seamless streaming experience. The app allows users to browse and watch world free live TV channels, switch between different languages, and access high-quality video content .</li></ul>",
        website: "https://github.com/SBKrishnan/BreakTimeTv",
      },
    ],
    skillSets: [
      "JavaScript",
      "React",
      "React Native",
      "TypeScript",
      "HTML",
      "CSS",
      "Firebase",
      "Java",
      "SpringBoot",
      "RESTful API",
      "Node.js",
      "MongoDB",
      "Figma",
      "AWS",
      "Docker",
      "CI/CD",
      "Git",
      "GitHub",
      "Python",
      "Data Preprocessing",
      "Matplotlib",
      "Seaborn",
      "Scikit-learn",
      "Machine learning",
      "Deep learning",
      "Excel",
      "SQL",
      "PowerBI",
      "Adaptablity",
      "Creativity",
      "Collaboration",
      "Critical Thinking",
      "Problem Solving",
    ],
    inspirations: ["APJ Abdul Kalam", "Warren Buffett"],
    socialLinks: {
      linkedIn: "https://linkedin.com/in/bala-krishnan-bk",
      gitHub: "https://github.com/SBKrishnan",
      website: "",
    },
  },
  {
    id: "prasanna",

    name: "Prasanna",

    picture: "jpg",

    role: "Backend Dev Engineer | Technical Analyst",

    email: "prasannap0218@gmail.com",

    summary:
      "<ul><li>Innovative FullStack Developer , with a Strong foundation in Trending Technologies and ,Passion for creating the Websites to be More scalable , more Efficient and with the optimized Performance.</li></ul>",

    experience: [
      {
        company: "Sarva Vidhya Solutions",

        role: "Full stack Developer Intern",

        summary:
          "<ul><li>Built an ESS application with Express.js, MySQL, and JWT for managing employee leave records, featuring a secure admin-only dashboard for approvals.</li><li>Built an Invoice Generator using Express.js and Puppeteer to generate invoices in PDF and image formats, with secure authentication for controlled access.</li></ul>",
      },
    ],

    mentorBridgeExp: {
      company: "Securosphere",

      role: "Co-Founder | Technical Analyst",

      summary:
        "<ul><li>Collaborated across frontend and backend teams to analyze user journeys and system performance, improving overall platform efficiency.</li><li>Prepared detailed API documentation to support data integration and ensure clarity for development teams.</li></ul>",

      website: "https://www.securosphere.in/",
    },

    skillSets: ["React", "Node.js", "Spring Boot", "AWS", "Docker", "CI/CD"],

    inspirations: ["APJ Abdul Kalam"],

    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/p-prasanna-817b9027b/",

      gitHub: "https://github.com/Prasanna0218",

      website: "https://prasanna0218.github.io/Personal-Portfolio/",
    },
  },
  {
    id: "Nivethitha_M",
    name: "Nivethitha M ",
    picture: "jpeg",
    role: "Backend Dev Engineer",
    email: "nivethitha029@gmail.com",
    summary:
      "<ul><li> A passionate Front-End Developer with a strong foundation in HTML, CSS, JavaScript, and modern frameworks like React.js. Skilled in building responsive, user-friendly web applications, I specialize in media queries, Bootstrap, and Node.js to create seamless experiences across devices. I have hands-on experience with API integration, UI/UX optimization, and email automation using Nodemailer in Node.js. With growing proficiency in the MERN stack(Express.js, React.js, Node.js), I am continuously learning and adapting to new technologies. I am seeking opportunities to grow as a Mern stack developer and contribute to innovative, dynamic projects.  </li></ul>",
    experience: [
      {
        company: "Virtual Technology",
        role: "Web Developer",
        summary:
          "<ul><li>  created a project Repair & Maintenance Service Website Clone and using Technologies like HTML, CSS, Media Queries, Responsive Design Designed product interfaces and user flows, contributing to the overall user experience of the platform.</li><li>Created API documentation to facilitate easy understanding and implementation.</li></ul>",
        website: "https://nivethithaabilash.github.io/Responsive-Website/",
      },
      {
        company: "Seval software solutions",
        role: "front-end developer and UI/UX designer ",
        summary:
          "<ul><li>  worked in the project Event Management System and used Technologies like  HTML, CSS, JavaScript, Media Queries, figma. Built a fully functional system that allows users to view, register, and manage events through a dynamic and user-friendly interface Implemented responsive design using media queries to ensure adaptability across devices.</li></ul>",
        website:
          "https://nivethithaabilash.github.io/EventManagement--Website/",
      },
    ],

    mentorBridgeExp: {
      company: "StubLab",
      role: "Co-Founder | Backend Dev Engineer",
      summary:
        "<ul><li>Developed flexible API endpoints in Node.js with support for dynamic path/query parameters to simulate real-world backend behaviour.</li><li>Integrated Node mailer and Postman to trigger email actions using API requests. Each trigger sent customized emails using React Email templates.</li><li>Created responsive, professional-grade email templates in React. These templates were reusable and suitable for organizational communication like welcome emails, password resets, and alerts.Generated Swagger documentation for each API/email template created. This included details such as endpoint URL, method, parameters, and sample request/response structures.Enabled automatic API documentation updates during development.</li></ul>",
      website: "https://www.stublab.in/",
    },

    skillSets: [
      "React",

      "HTML",

      "Node.js",

      "CSS",

      "JavaScript",

      "bootstrap",

      "UI/UX",

      "mediaquery",

      "express.js",
    ],

    inspirations: ["APJ Abdul Kalam", "Ratan Tata"],

    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/nivethitha01/",
      gitHub: "https://github.com/NivethithaAbilash",
      website: "",
    },
  },
  {
    id: "bavani",
    name: "Bavani K",
    picture: "jpg",
    role: "Mobile App Developer",
    email: "bavanikannan2412@gmail.com",
    summary:
      "<ul><li>Passionate mobile app developer with skills in React Native, Flutter, React.js, and UI/UX design.</li><li>Experienced in building responsive apps and crafting seamless user experiences using Figma</li></ul>",
    experience: [
      {
        company: "Accent Techno Soft",
        role: "Mobile App Developer ",
        summary:
          "<ul><li>Designed product interfaces and user flows, contributing to the overall user experience of the platform.</li><li>Created Built a mobile app to help users track daily calorie intake and monitor health goals.</li></ul>",
        website: "http://stupro.info",
      },
      {
        company: "Savel Software",
        role: "Mobile App Developer ",
        summary:
          "<ul><li>Designed product interfaces and user flows, contributing to the overall user experience of the platform.</li><li>Create a Flutter mobile app to find and connect with local area workers. Features user-friendly UI, location-based search, and worker profile browsing.</li></ul>",
        website: "http://stupro.info",
      },
    ],
    mentorBridgeExp: {
      company: "StuPro",
      role: "Co-Founder | Mobile App Developer|Frontend Dev Engineer",
      summary:
        "<ul><li>Designed product interfaces and user flows, contributing to the overall user experience of the platform.</li><li>Created A productivity app for students developed with React Native. Built key mobile app features using React Native and TypeScript, including dynamic UI components with real-time data integration.</li></ul>",
      website: "http://stupro.info",
    },
    skillSets: [
      "ReactNative",
      "TypeScript",
      "Node.js",
      "Flutter",
      "Html",
      "Css",
      "JavaScript",
    ],
    inspirations: ["Virat Kohli"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/bavani-kannan-b15938287/",
      gitHub: " https://github.com/bavanikannan12",
    },
  },
  {
    id: "meena",
    name: "Meena S",
    picture: "jpg",
    role: "Mobile Application Developer | Technical Analyst",
    email: "meenasivakumar44@gmail.com",
    summary:
      "<ul><li>Passionate and detail-oriented Mobile App Developer with expertise in Flutter, React Native, and Java. Experienced in building scalable applications, integrating APIs, and working with Firebase for real-time data management.</li></ul>",
    experience: [
      {
        company: "Accent Techno Soft",
        role: "Mobile App Developer",
        summary:
          "<ul><li>Gained hands-on experience with the Flutter framework and Sqflite database. Developed a Tour Guide App that showcases popular destinations, enabling users to share visited locations, upload images, and add descriptive insights.</li></ul>",
        website: "",
      },
      {
        company: "NSCI",
        role: "Mobile App Developer",
        summary:
          "<ul><li>Technologies: Java, WeatherAPI, GPS, Volley, Picasso, RecyclerView. Developed an Android weather app that provides real-time forecasts using WeatherAPI. Integrated GPS-based updates for location-based weather, used Volley for fast network requests, Picasso for image loading, and RecyclerView for smooth data display.</li><li> Features: Live Weather Updates -Temperature, Humidity, Wind Speed. GPS-based Location Tracking for Accurate Forecasts.Optimized API Calls with Volley for Efficient Data Retrieval. Smooth UI with RecyclerView & Picasso.</li></ul>",

        website: "https://github.com/MeenaSivakumar/WeatherApp",
      },
    ],
    mentorBridgeExp: {
      company: "StuPro",
      role: "Co-Founder | Technical Analyst",
      summary:
        "<ul><li>Designed and developed the Feedback Page, enabling users to submit feedback seamlessly. Created the Change Password Page with secure validation and API integration.Resolved UI/UX issues and optimized the interface for a better user experience. Developed a secure API for user authentication via OTP validation. Created an endpoint to store user feedback in the database.Automated the retrieval of AI-generated daily challenges, coding tasks, quizzes, and tech facts.Implemented a cron scheduler to fetch and store this data periodically in MongoDB.</li></ul>",

      website: "http://stupro.info",
    },
    skillSets: [
      "Java",
      "TypeScript",
      "React",
      "Javascript",
      "Flutter",
      "SpringBoot",
      "Figma",
      "Git",
      "GitHub",
    ],
    inspirations: ["Virat Kohli", "Kunal Kushwaha"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/meena-34-b59912268/",
      gitHub: " https://github.com/MeenaSivakumar",
      website: "",
    },
  },
  {
    id: "Subash",
    name: "Subash Natrayan",
    picture: "jpg",
    role: "Frontend Dev Engineer",
    email: "subashnatrayan6@gmail.com",
    summary:
      "<ul><li>My role involves strategic planning, product development, and team coordination to ensure the platform meets industry standards and user expectations.</li><li>My journey started with a fascination for how technology shapes our world, and before I knew it, I was co-founding startups like ProtecWatch and Stupro, leading front-end teams, and building solutions that bridge the gap between ideas and execution.</li><li>Whether it's crafting seamless UI/UX, integrating machine learning into sign language translator hardware, or tackling real-world problems through hackathons, I thrive on challenges that push me beyond my limits.</li></ul>",
    experience: [
      {
        company: "Virtual Tech Services",
        role: "AI/ML Intern",
        summary:
          "<ul><li>During my AI/ML internship at Virtual Tech Services, I was actively involved in building and optimizing machine learning models for real-world applications.</li><li>I gained hands-on experience in data preprocessing, analyzing large datasets, and implementing machine learning techniques and transformers to improve model performance.</li><li>Additionally, I worked on deploying AI models in production environments, ensuring seamless integration and practical impact.</li><li>This internship provided me with valuable exposure to cutting-edge AI technologies and real-world problem-solving.</li></ul>",
        website: "https://virtualtechz.in/",
      },
      {
        company: "Tarcin Robotics",
        role: "Product Developer",
        summary:
          "<ul><li>As a Product Developer at Tarcin Robotics,  I was involved in designing and developing innovative robotic solutions tailored for automation and real-world applications.</li><li>I worked on integrating hardware and software components to enhance robotic functionality, ensuring seamless interaction between sensors, actuators, and control systems.</li><li>Additionally, I collaborated with cross-functional teams to optimize product performance, troubleshoot issues, and contribute to the overall improvement of robotic prototypes, gaining hands-on experience in both product development and real-world implementation.</li></ul>",
        website: "https://tarcinrobotics.in/",
      },
      {
        company: "Acmegrade",
        role: "Cybersecurity Intern",
        summary:
          "<ul><li>Conducted vulnerability assessments and penetration testing on web applications to identify security flaws and recommend mitigation strategies.</li><li>Gained hands-on experience in network security, encryption techniques, and implementing security measures to protect sensitive data.</li><li>Explored ethical hacking methodologies, working with tools like Kali Linux, Metasploit, and Wireshark to analyze and strengthen system defenses.</li></ul>",
        website: "https://acmegrade.com/",
      },

      {
        company: "Project Contest Innovation LLP",
        role: "Cybersecurity Intern",
        summary:
          "<ul><li>Worked on real-world cybersecurity projects, identifying threats and implementing security protocols to safeguard digital assets.</li><li>Conducted security audits and compliance checks to ensure systems adhered to industry standards and best practices.</li></ul>",
        website: "https://projectcontest.com/",
      },
      {
        company: "ProtecWatch",
        role: "Co-Founder",
        summary:
          "<ul><li>As a Co-Founder of ProtecWatch, I played a pivotal role in developing a Security Watch for women safetey and cutting-edge sign language translator hardware solution.</li><li>My responsibilities included designing the hardware architecture, integrating machine learning algorithms for real-time translation, and ensuring seamless communication between the device and user interfaces.</li><li>This project not only showcased my technical skills but also highlighted my commitment to creating inclusive technology that bridges communication gaps.</li></ul>",
      },
    ],

    mentorBridgeExp: {
      company: "StuPro",
      role: "Co-Founder | Lead Frontend Development Engineer",
      summary:
        "<ul><li>As a Co-Founder of Stupro App, I lead the development of an innovative platform designed to assist students in transitioning from academia to professional careers. My role involves strategic planning, product development, and team coordination to ensure the platform meets industry standards and user expectations.</li><li>I am also responsible for creating modules such as DeepLink, ArticleShare, ShareWithArticle, Push Notification, Swipe Card creation, Text-to-Speech conversion, Conversion to PDF, NativeBase package integration, Firebase configuration, animation, navigation, and API integration.</li></ul>",
      website: "http://stupro.info",
    },

    skillSets: [
      "React",
      "TypeScript",
      "Node.js",
      "Python",
      "AWS",
      "Docker",
      "Art Designs",
      "Machine Learning",
      "Spring Boot",
      "Kali Linux",
      "Agile Methodologies",
      "GitHub",
      "CI/CD",
    ],

    inspirations: ["Nikola Tesla", "Akihiko Kayaba"],

    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/subash-natrayan-r-m-4654aa319",
      gitHub: "https://github.com/Thunderscotch",
    },
  },
  {
    id: "Sivasankari",
    name: "Sivasankari",
    picture: "jpg",
    role: "Backend dev Engineer",
    email: "sivasankarikannan16@gmail.com",
    summary:
      "<ul><li>Dynamic Java Backend Developer with extensive experience in crafting robust applications and systems.</li><li>Committed to continuous learning and professional growth, aiming to excel in the Java development landscape.</li></ul>",
    experience: [
      {
        company: "Profenna Technology",
        role: "Embedded IOT Engineer",
        summary:
          "<ul><li>Gaining hands-on experience in IoT systems, sensor integration, and microcontroller programming..</li><li>Developed and implemented real-time embedded solutions for automation and smart devices.</li></ul>",
      },
      {
        company: "RailNet",
        role: "RailNet Internship Trainee",
        summary:
          "<ul><li>Completed an internship at RailNet, gaining insights into the fundamentals of railway operations and infrastructure.</li><li>Learned about railway functionalities, signaling systems, and network management.</li></ul>",
      },
    ],
    mentorBridgeExp: {
      company: "SecuroSphere",
      role: "Co-Founder | Backend Dev Engineer",
      summary:
        "<ul><li>In the role of Java Backend Developer at Mentor Bridge, expertise in building robust backend solutions using Java and Spring Boot is applied.</li><li>This position involves designing and implementing RESTful APIs to support frontend functionalities while ensuring high performance and responsiveness.</li></ul>",
      website: "https://www.securosphere.in/",
    },
    skillSets: [
      "Java",
      "Springboot",
      "MongoDB",
      "SQL",
      "AWS",
      "Docker",
      "CI/CD",
    ],
    inspirations: ["APJ Abdul Kalam", "Virat Kholi"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/sivasankari-k-3643b8266",
      gitHub: "https://github.com/sivasankari-kannan",
    },
  },
  {
    id: "Vijaykarthik",
    name: "Vijaykarthik S",
    picture: "png",
    role: "Frontend Dev Engineer",
    email: "vijaykarthik.cse2025@gmail.com",
    summary:
      "<ul><li>I am a passionate Full Stack Developer with experience in building web applications using the MERN stack.</li><li>I have worked on various projects, including web applications, and I enjoy creating user-friendly and responsive web apps.</li><li>My expertise includes JavaScript, React, Node.js, Express, and MongoDB, ensuring efficient and high-performance applications.</li><li>I am continuously learning and keeping up with the latest trends in full-stack development.</li></ul>",
    experience: [
      {
        company: "Seval Software Solutions",
        role: "Frontend Dev Engineer",
        summary:
          "<ul><li>Developed an e-commerce website using React and Tailwind CSS as per company requirements.</li><li>Designed and implemented responsive UI components for an enhanced user experience.</li><li>Documented front-end features for better maintainability and future updates.</li></ul>",
      },
    ],
    mentorBridgeExp: {
      company: "StubLab",
      role: "Co-Founder | Frontend Dev Engineer",
      summary:
        "<ul><li>Built an interactive application page where users can enter their details with proper form validation using Yup.</li><li>Connected frontend with APIs to ensure smooth data flow and real-time updates.</li><li>Redesigned the landing page to enhance user engagement and aesthetics, ensuring a seamless experience across devices.</li></ul>",
      website: "https://stublab.in/",
    },
    skillSets: [
      "Java",
      "HTML",
      "CSS",
      "Bootstrap",
      "Tailwind CSS",
      "JavaScript",
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Git/GitHub",
    ],
    inspirations: ["Elon Musk", "Virat Kohli"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/vijaykarthik-s-3b3930287/",
      gitHub: "https://github.com/Vijaykarthik1",
      website: "https://portfolio-vijaykarthik-1.web.app/",
    },
  },
  {
    id: "Vishwadharshini",
    name: "Vishwadharshini V",
    picture: "jpg",
    role: "UX Designer",
    email: "vishwadharshini1793@gmail.com",
    summary:
      "<ul><li>A UX designer passionate about creating user-friendly interfaces. I specialize in React Native and UI/UX design, focusing on building smooth and engaging digital experiences..</li><li>Currently, I contribute to StuPro, a platform that helps students transition into professionals. My role involves UI UX design, frontend development, and product marketing to make the platform more intuitive and effective.</li></ul>",
    mentorBridgeExp: {
      company: "StuPro",
      role: "Co-Founder | UX designer | Frontend Dev Engineer |",
      summary:
        "<ul><li>Logo and vectors – Designed logo for Stupro and different vectors to enhance user experience</li><li>Mockups – Designed mockups for Stupro to showcase our product</li><li>Preference UI Design – Designed an intuitive preference page to enhance user learning and make it personalized.</li><li>Sentence of the day Page– Developed sentence of the day page to boost user interaction.</li><li>API Integration – Connected the frontend with the backend for seamless data flow.</li></ul>",
      website: "http://stupro.info",
    },
    skillSets: [
      "UI/UX design",
      "Graphic design",
      "JavaScript",
      "React Native",
      "TypeScript",
      "Html",
      "css",
    ],
    inspirations: ["Don Norman", "Marie curie", "Senthil Kumar T"],
    socialLinks: {
      linkedIn: "https://www.linkedin.com/in/vishwa-dharshini",
      gitHub: "https://github.com/Vishwadharshinivinod",
      website: "",
    },
    experience: [],
  },
  {
    id: "Santhana_Kaleeswari_S",
    name: "Santhana Kaleeswari S",
    picture: "jpg",
    role: "Mobile App Developer",
    email: "kaleeswari3167@gmail.com",
    summary:
      "<ul><li>A Proficient in React Native with hands-on experience in Flutter for mobile app development, along with JavaScript, HTML, and CSS.Passionate about mobile app development and UI/UX design, focusingon building scalable, high-performance, and user-friendly applications.</li></ul>",
    experience: [
      {
        company: "Accent Techno Soft",
        role: "Mobile App Developer",
        summary:
          "<ul><li>Designed product interfaces and user flows, contributing to the overall user experience of the platform.</li><li>Gained hands on knowledge in mobile app development framework.Developed mobile applications using flutter and sqlite</li></ul>",
        website: "http://stupro.info",
      },
    ],
    mentorBridgeExp: {
      company: "StuPro",
      role: "Co-Founder | Mobile App Developer",
      summary:
        "<ul><li>Designed product interfaces and user flows, contributing to the overall user experience of the platform.</li><li>UI Design using Figma and User Experience.Worked on Front end using React Native</li></ul>",
      website: "http://stupro.info",
    },
    skillSets: [
      "React",
      "TypeScript",
      "React native",
      "Flutter",
      "Html",
      "CSS",
      "Js",
    ],
    inspirations: ["APJ Abdul Kalam"],
    socialLinks: {
      linkedIn:
        "https://www.linkedin.com/in/santhana-kaleeswari-seenivasan-17082b293",
      gitHub: "https://github.com/santhanakaleeswari",
    },
  },
];
